import { Tag } from '@cencosud-cencommerce/paris-uikit';

import { useAppSelector } from '@/Application/Hooks/Redux';
import { PAYMENT_METHODS } from '@/modules/perseo-billing/constants/src/providers/payment-methods';
import { useGiftCardData } from '@/modules/perseo-billing/hooks';
import { useMediaQuery } from '@/modules/perseo-billing/ui/react/src';
import { Typography } from '@/modules/perseo-billing/ui/react/src/components/beta';

interface ShowPromoTextProps {
  id?: string;
  label?: string | null;
}
export const ShowPromoText = ({ id, label }: ShowPromoTextProps) => {
  const { data: cart } = useAppSelector((state) => state.cart);
  const { cartHasGiftCardPayment } = useGiftCardData();
  const isMobile = useMediaQuery('lg');
  if (!cart) return <></>;

  const isCencosud = id === PAYMENT_METHODS?.EPAY_CENCOSUD_TCOM;

  if (!isCencosud) {
    return null;
  }

  const hasGiftCard = cartHasGiftCardPayment();

  if (hasGiftCard && isCencosud) {
    return <DiscountNotCumulative />;
  }

  return label ? (
    <Tag className="co-w-fit" size={isMobile ? 'md' : 'lg'} variant="offers">
      {label}
    </Tag>
  ) : null;
};

export const DiscountNotCumulative = () => {
  return (
    <Typography
      size="body2"
      weight="semibold"
      className="co-bg-[#FFFCE0] co-border-1 co-border-[#DA7400] co-px-1 co-rounded-4px"
    >
      Dscto. no acumulable con Gift Card
    </Typography>
  );
};
